import { render } from "./FormBurg.vue?vue&type=template&id=2a54572b&scoped=true"
import script from "./FormBurg.vue?vue&type=script&lang=js"
export * from "./FormBurg.vue?vue&type=script&lang=js"

import "./FormBurg.vue?vue&type=style&index=0&id=2a54572b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a54572b"]])

export default __exports__